import React, { PureComponent } from 'react'
import T from 'prop-types'
// import _ from 'lodash'
import IT from 'react-immutable-proptypes'
import {
  // TextInput,
  ScrollBars,
  // CircleLoader,
  AnimateHeight,
  SaveButton,
  ErrorState,
  DataTable,
  // Button
  DimensionAware,
  TextOverflowCenterLite
} from 'react-base'
import {
  is,
  Map,
  List,
  OrderedMap,
  Iterable
} from 'immutable'
import Schema from '../Schema'
import {
  SCHEMA_ITEM_SHAPE,
  COLUMN_SHAPE,
  SCHEMA_SHAPE
} from '../shapes'

export default class ColHeaderCell extends PureComponent {
  static propTypes = {
    schema: SCHEMA_SHAPE.isRequired,
    columnKey: T.oneOfType([T.string, T.number]).isRequired,
    column: COLUMN_SHAPE,
    isSticky: T.bool,
    onStickyChange: T.func,
    columnHeaderComponent: T.oneOfType([T.element, T.func]), // React Component or Functional/Stateless component
    columnHeaderComponentProps: IT.mapOf(T.any, T.string)
  }

  static defaultProps = {
    columnHeaderComponentProps: Map()
  }

  handleStickyBtnClick = () => {
    this.props.onStickyChange(this.props.columnKey)
  }

  render() {
    const {
      column,
      columnKey,
      schema,
      isSticky,
      columnHeaderComponent,
      columnHeaderComponentProps
    } = this.props

    const schemaDef = schema.get(columnKey)
    const nestedSchema = schemaDef.get('schema')
    const defaultContent = schemaDef.get('display') //column.has('formatHeader') ? column.get('formatHeader')(datum, column) : datum
    const isMultiline = column.getIn(['table', 'multiline'], false)
    const ColHeaderComponent = columnHeaderComponent

    return (
      <div
        className={`schemer_header_cell_content`}
      >
        <div className={`header_buttons`}>
          {column.get('stickyable') &&
            <span
              className={`btn btn-icon icon-pushpin sticky_btn ${isSticky ? 'is_stickyable' : ''}`}
              onClick={this.handleStickyBtnClick}
            />
          }
        </div>
        <div>
          {ColHeaderComponent ? (
            <ColHeaderComponent
              columnKey={columnKey}
              column={column}
              schemaDef={schemaDef}
              schema={schema}
              {...(columnHeaderComponentProps ? columnHeaderComponentProps.toObject() : {})}
            />
          ) : typeof defaultContent === 'string' && !isMultiline ? (
            <TextOverflowCenterLite
              value={defaultContent}
            />
          ) : defaultContent}
        </div>
        {column.has('columns') && nestedSchema &&
          <div className="schemer_header_row_nested">
            {column.get('columns').entrySeq().map(([nestedColumnKey, nestedColumn]) => {
              return (
                <div
                  key={nestedColumnKey}
                  className={`schemer_header_cell_nested`}
                  style={{
                    width: nestedColumn.get('width')
                  }}
                >
                  <ColHeaderCell
                    column={nestedColumn}
                    columnKey={nestedColumnKey}
                    schema={nestedSchema}
                  />
                </div>
              )
            })}
          </div>
        }
      </div>
    )
  }

}